import { useEffect, useRef } from "react";
import { useQuery } from "@powersync/react";
import { useApp } from "@/app/AppContext";
import { useCelebrate } from "./celebrate";

// When a visit that was open finishes on someone's phone while this tab is
// open, the Bukkie drives by. Only transitions observed live count: nothing
// fires on page load or for historical data.
export function VisitWatcher() {
  const { teamId } = useApp();
  const celebrate = useCelebrate();
  const { data } = useQuery<{ id: string; done: number; label: string | null; who: string | null }>(
    `SELECT fn.id, fn.completed_at IS NOT NULL AS done, mf.label, u.name AS who FROM mobile_field_notes fn
     LEFT JOIN map_features mf ON mf.id = fn.map_feature_id LEFT JOIN maps m ON m.id = mf.map_id
     LEFT JOIN mobile_team_users u ON u.user_id = fn.user_id AND u.team_id = m.team_id
     WHERE m.team_id = ? AND (fn.completed_at IS NULL OR fn.completed_at > datetime('now', '-1 day'))`, [teamId]);
  const open = useRef<Set<string> | null>(null);
  useEffect(() => {
    const nowOpen = new Set(data.filter((d) => !d.done).map((d) => d.id));
    if (open.current) {
      const finished = data.find((d) => d.done && open.current!.has(d.id));
      if (finished) celebrate({ kind: "visit", title: "Visit wrapped up", sub: [finished.who, finished.label].filter(Boolean).join(" · ") });
    }
    open.current = nowOpen;
  }, [data, celebrate]);
  return null;
}
